import "bulma/css/bulma.css";
import "../../index.css";
import ComingSoon from "../../assets/dash.png"
import { useMediaQuery } from 'react-responsive'

export default function Dashboard() {
  document.title = "Halaman Utama";
  const username = localStorage.getItem("name-admin");
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 780px)'})

  const today = new Date();

  const formattedDate = today.toLocaleDateString("id-ID", {
    weekday: "long",  
    day: "2-digit",    
    month: "long",    
    year: "numeric",  
  });

  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  const toTitleCase = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";
    return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
  };

  const toTitleCaseGelar = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";

    return s
      .split(" ")
      .map((word) => {
        // khusus gelar yang ada titik, contoh: s.si. -> S.Si.
        if (word.includes(".")) {
          return word
            .split(".")
            .map((part) => {
              if (!part) return "";
              return part.charAt(0).toUpperCase() + part.slice(1);
            })
            .join(".");
        }

        // normal title case, contoh: helmy -> Helmy
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  };


  return (
    <div className="body" >

      <div className="page-header-card">
              <div className="page-header-top d-flex">
                {isTabletOrMobile ? (
                  <>
                    <div className="title-dashboard">
                      <h4>Assalamualaikum, {toTitleCaseGelar(username)} 😊</h4>
                      <h5 style={{color: '#2e52b3', fontSize: '16px'}}>{formattedDate}</h5>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="title-dashboard">
                      <h4>Assalamualaikum, {toTitleCaseGelar(username)}  😊</h4>
                      <h5 style={{color: '#2e52b3', fontSize: '18px'}}>{formattedDate}</h5>
                    </div>
                  </>
                )}
              </div>
            </div>
            
            <div className="body-content text-center" style={{padding: "30px 0"}}>
             
              {isTabletOrMobile ? (
                <>
                <img src={ComingSoon} className="img-fluid" style={{width:"100%",  marginBottom:"15px",  padding: "0 15px"}} />
                {/* <h6 style={{color: '#fdad00', fontSize: '16px'}}>Halaman utama dalam pengembangan..</h6> */}
                </>
              ):(
                <>
                <img src={ComingSoon} className="img-fluid" style={{width:"60%", marginBottom:"15px"}} />
                {/* <h5 style={{color: '#fdad00'}}>Halaman utama dalam pengembangan..</h5> */}
                </>
              )}
              
            </div>

    </div>
  );
}
